'use strict';

angular.module('shiftTraderApp')
  .directive('saUsersPositionsStars', function () {
    return {
      template: '<div class=\"sa-users-position-stars\">' +
        '<i class="icon-star-empty num-stars-0" style=\"display:inline-block; opacity:.7;\" data-ng-click=\"setRank(0); $event.stopPropagation();\"></i>' +
        '<i class=\"icon-star num-stars-1\" style=\"display:inline-block\" data-ng-click=\"setRank(1); $event.stopPropagation();\"></i>' +
        '<i class=\"icon-star num-stars-2\" style=\"display:inline-block\" data-ng-click=\"setRank(2); $event.stopPropagation();\"></i>' +
        '<i class=\"icon-star num-stars-3\" style=\"display:inline-block\" data-ng-click=\"setRank(3); $event.stopPropagation();\"></i>' +
        '</div>',
      restrict: 'EA',
      scope: {
        usersPosition: '=',
        callback: '='
      },
      link: function postLink(scope, element) {
        var stars = [
          element.find('.num-stars-0'),
          element.find('.num-stars-1'),
          element.find('.num-stars-2'),
          element.find('.num-stars-3')
        ];

        var changeStars = function(numStars) {
          if (numStars > 0) {
            _.forEach(_.range(1,4), function(r) {
              if (numStars >= r) {
                stars[r].addClass('icon-star');
                stars[r].removeClass('icon-star-empty');
              } else {
                stars[r].removeClass('icon-star');
                stars[r].addClass('icon-star-empty');
              }
            });
          } else {
            _.forEach(stars, function(star) {
              star.removeClass('icon-star');
              star.addClass('icon-star-empty');
            });
          }
        };
        changeStars(scope.usersPosition.ranking);

        _.forEach(stars, function(star) {
          star.hover(function(evnt) {
            changeStars((function() {
              var temp = _.find(evnt.currentTarget.classList, function(className) {
                //clever, clever Matt.
                return className.indexOf('um-stars-') > 0;
              });
              return temp.slice(temp.length-1);
            }()));
          }, function() {
            changeStars(scope.usersPosition.ranking);
          });
        });


        scope.setRank = function(rank) {
          changeStars(rank);
          console.log('setRank', rank);
          scope.usersPosition.ranking = rank;
          scope.usersPosition._modified = true;

          if (scope.callback) {
            scope.callback()
          }
        };
      }
    };
  });
